import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from '@sensei/pi-component';

const useAddYourDeviceStyles = makeStyles((theme: Theme) =>
    createStyles({
        dialogContent: {
            width: '100%',
        },
        dialogPaper: {
            textAlign: 'center',
            color: theme.palette.text.secondary,
            height: '156px',
            width: '80%',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
            margin: '0 auto',
            marginTop: theme.spacing(4),
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: colors.CANOPY,
        },
        dialogPaperContent: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dialogPaperLogo: {
            width: '120px',
        },
        dialogButton: {
            marginTop: theme.spacing(6),
        },
        activateLater: {
            margin: theme.spacing(5, 0),
            fontWeight: 500,
            color: colors.CARBON,
            fontSize: '14px',
            fontFamily: 'Theinhardt',
        },
    }),
);

export default useAddYourDeviceStyles;
